var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon Color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.51097L2.49687 0L3.66771 1.17085L9 6.48903V9H6.48903L0.973354 3.49843L0 2.51097ZM0.789968 2.51097L1.38244 3.10345L3.08934 1.38245L2.51097 0.789969L0.789968 2.51097ZM8.43574 7.2931L7.26489 8.43574H8.43574V7.2931ZM6.60188 8.30878L8.33699 6.61599L3.49843 1.79154L1.77743 3.49843L6.60188 8.30878Z",
    fill: "#246DCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilBlue);
export default __webpack_public_path__ + "static/media/pencil-blue.477bdb5d9dc950b316dc49981c08575f.svg";
export { ForwardRef as ReactComponent };